import { Children, useCallback, useEffect, useState } from "react";

import { Link } from "react-router-dom";
import SectionTitle from "../../components/general/misc/SectionTitle";
import { getPinnedProducts } from "../../services/homeRequestServices";
import productsSvg from "../../assets/media/icons/products.svg";
import styled from "styled-components";
import variables from "../../assets/js/variables";

const { colors } = variables;

const Products = () => {
  const [productsData, changeProductsData] = useState([]);

  const getProductsData = useCallback(() => {
    return getPinnedProducts().then(({ results }) =>
      changeProductsData(results)
    );
  }, []);

  useEffect(() => {
    getProductsData();
  }, [getProductsData]);

  return (
    <div className="home_products__container d-flex flex-column align-items-center justify-content-center p-3 pb-0 p-md-5 pb-md-0 mx-md-5">
      <TitleRow className="d-flex w-100 mb-5">
        <div className="d-flex">
          <SectionTitle iconSrc={productsSvg} text="محصولات هوش‌آیند" />
        </div>
        <Link
          to="/products"
          className="btn btn-sm px-4 bg-blue text-white border-radius-10"
        >
          مشاهده همه محصولات
        </Link>
      </TitleRow>
      <ProductList className="d-flex flex-wrap justify-content-center">
        {Children.toArray(
          productsData.map((item) => (
            <ProductCard className="d-flex flex-column border-radius-10 p-3">
              {item.logo?.url ? (
                <ProductIcon
                  className="mb-3"
                  src={item.logo.url}
                  alt={item.title}
                />
              ) : null}
              <h3 className="text-16 text-green">{item.title}</h3>
              <h3 className="text-16 text-white">{item.slogan}</h3>
              <p className="text-14 font-weight-100 text-white mt-1">
                {item.slogan_description}
              </p>
              <Link
                to={`/products/${item.id}/${item.slug}`}
                className="mt-4 text-green text-28"
              >
                <span className="d-block icon-add-outline"></span>
              </Link>
            </ProductCard>
          ))
        )}
      </ProductList>
    </div>
  );
};

export default Products;

const TitleRow = styled.div`
  align-items: center;
  justify-content: space-between;
`;

const ProductList = styled.div`
  margin: -0.5rem;
`;

const ProductCard = styled.div`
  background-color: ${colors.darkBlue};
  border: solid 1px ${colors.darkBlue};
  max-height: 390px;
  width: 255px;
  margin: 0.5rem;
  line-height: 24px !important;

  &:hover {
    border-color: ${colors.green};
  }

  h3 {
    overflow: hidden;
    text-overflow: ellipsis;
    flex-shrink: 0;
  }

  p {
    flex-grow: 1;
    overflow: hidden;
  }
`;

const ProductIcon = styled.img`
  width: 48px;
  height: 48px;
`;
